import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import language files
import enTranslation from './locales/en.json';
import etTranslation from './locales/et.json';

const AUTO_DETECT_ON_FIRST_VISIT = true;

// Configure i18next
i18n
// Detect user language
	.use(LanguageDetector)
// Pass the i18n instance to react-i18next
	.use(initReactI18next)
// Initialize i18next
	.init({
		resources: {
			en: {
				translation: enTranslation,
			},
			et: {
				translation: etTranslation,
			},
		},
		fallbackLng: 'en',
		debug: process.env.NODE_ENV === 'development',
    
		interpolation: {
			escapeValue: false, // React already escapes values
		},
    
		// Save language preference to localStorage
		detection: AUTO_DETECT_ON_FIRST_VISIT ? {
			order: ['querystring', 'localStorage', 'navigator'],
			caches: ['localStorage'],
			lookupQuerystring: 'lang',
		} : {
			order: ['querystring', 'localStorage'],
			caches: ['localStorage'],
			lookupLocalStorage: 'i18nextLng',
			lookupQuerystring: 'lang',
		},
	});

export default i18n; 